<template>
    <div>
        <the-header></the-header>
        <the-crumb v-if="showCrumb"></the-crumb>
        <router-view class="main_content"></router-view>
        <the-footer></the-footer>
    </div>
</template>
<script>
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'
import TheCrumb from './TheCrumb'
export default {
    name: 'publicLayout',
    components: {TheHeader,TheFooter,TheCrumb},
    data() {
        return {
            hide_crumb:['MainIndex']
        }
    },
    computed:{
        showCrumb(){
            return !(this.hide_crumb.indexOf(this.$route['name'])>-1)
        }
    },
    created(){},
    methods: {},
}
</script>
<style lang='scss' scoped>
</style>